export enum TeethNumberingSystem {
	FDI = 0,
	ADA = 1,
	Quadrant = 2
}
